import { apiSlice } from "../../app/api/apiSlice";

export const fetchAEEmailsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		fetchAEEmails: builder.mutation({
			query: ({ broker_id, loan_processor_broker_id }) => ({
				url: "/api/v1/loan/ae/fetch_ae_emails/",
				method: "POST",
				body: { broker_id, loan_processor_broker_id },
			}),
		}),
	}),
});

export const { useFetchAEEmailsMutation } = fetchAEEmailsApiSlice;
